export default "__VITE_ASSET__Csao00Ej__"